<template>
  <div v-for="(image, index) in items" :key="image">
    <div class="loader__wrapper" :style="imageStyles(image, index)">
      <UiLoader
        :radius="10"
        color="var(--var-blue-100)"
        :circle-width="2"
      />
    </div>
  </div>
  <img
    v-for="(image, index) in items"
    :id="image"
    :key="image"
    :src="image"
    :ref="index === 0 ? 'videoFirstRef' : undefined"
    :class="imageClass(index)"
    @load="imageLoadHandler(image)"
    @click="fullSizeHandler(index)"
    alt="altImageDefault"
  />
</template>

<script setup lang="ts">
import {ref} from 'vue';

const props = defineProps<{
  items: any;
  firstImgWidth: number;
}>();

const emit = defineEmits<{
  (e: 'full-screen', index: number): void;
}>();

const fullSizeHandler = (index: number) => {
  emit('full-screen', index);
};

const loadImageForStart = ref<{[key: string]: boolean}>({});
const imageLoadHandler = (currentImage: string) => {
  loadImageForStart.value = {
    ...loadImageForStart.value,
    [currentImage]: true,
  };
};

const imageStyles = (image: any, index: number) => {
  return {
    left: `calc(${index * props.firstImgWidth + 'px'}`,
    zIndex: loadImageForStart.value[image] ? -1 : -1,
  };
};

const imageClass = (index: number) => {
  return {
    'gallery-video-loop_first': index === 0,
    'gallery-video-loop': true,
  };
};
</script>

<style scoped lang="scss">
.loader__wrapper {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: -1;
}

img {
  height: 700px;
  width: calc(100% / 1);
  object-fit: cover;
  margin-left: $m-3;

  &:first-child {
    margin-left: 0px;
  }

  @media (max-width: 900px) {
    width: calc(100% / 1);
  }

  @media (max-width: 720px) {
    width: 100%;
    height: 100%;
    border-radius: 4px;
  }
}

.gallery-video-loop {
  margin-left: 14px;

  &_first {
    margin-left: 0;
  }

  @media (max-width: 720px) {
    margin-left: 10px;
    min-height: 200px;

    &_first {
      margin-left: 0;
    }

    border-radius: 4px;
  }
}
</style>
